:host {
  display: block;
}
.active-tab{
  color: var(--mainColor);
  text-decoration: underline var(--mainColor);
  text-underline-offset: 8px;
  text-decoration-thickness: 1px;
}